var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"gstc",staticClass:"gstc-wrapper max-h-timeline-container app-calendar position-relative overflow-hidden text-sm"})}
var staticRenderFns = []

export { render, staticRenderFns }